import React, { useEffect, useState, useLayoutEffect} from "react";
import FilterBox from "../../Components/filterBox/filterBox";
import ReportDashboardStops from "../Reports/reportDashboardStops";
import TopBar from "../../Components/topBar/topBar";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";





const dashboardStops = () => {

   
    
    return(
        <>
        <header>
        <TopBar></TopBar>
        </header>
        <ReportDashboardStops />
        </>
       
    )
}



export default dashboardStops;